import { useState, useEffect } from "react";
import { CreditCard, Zap, X, Clock, Sparkles } from "lucide-react";
import dashboardPreview from "@/assets/auth-dashboard-preview.png";
import { cn } from "@/lib/utils";

const benefits = [
  {
    icon: CreditCard,
    title: "No card required",
    description: "Start your free trial without entering any payment details. Upgrade when you're ready.",
  },
  {
    icon: Zap,
    title: "2-minute setup",
    description: "Create your custom feedback page in minutes — no complex setup, no technical knowledge needed.",
  },
  {
    icon: X,
    title: "Cancel anytime",
    description: "No contracts, no commitments. Pause or cancel your subscription whenever you want.",
  },
  {
    icon: Clock,
    title: "15-day free trial",
    description: "Full access to every feature. Risk-free, no strings attached.",
  },
];

export const AuthSplitScreen = () => {
  const [currentBenefit, setCurrentBenefit] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentBenefit((prev) => (prev + 1) % benefits.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  const benefit = benefits[currentBenefit];
  const Icon = benefit.icon;

  return (
    <div className="hidden lg:flex lg:flex-1 p-6 min-h-screen items-stretch">
      <div className="marketing-theme relative flex-1 mkt-gradient-hero mkt-grain rounded-[2.5rem] overflow-hidden mkt-shadow flex items-center justify-center p-12 text-white">
        <div className="relative z-10 max-w-md w-full space-y-8">
          <span className="inline-flex items-center gap-2 rounded-full bg-white/15 backdrop-blur px-4 py-1.5 text-sm font-medium border border-white/20">
            <Sparkles className="h-3.5 w-3.5" />
            Anonymous by design
          </span>

          <div key={currentBenefit} className="space-y-4 animate-fade-in">
            <div className="flex items-center gap-3">
              <div className="p-2.5 rounded-2xl bg-white/15 backdrop-blur border border-white/20">
                <Icon className="h-6 w-6 text-white" />
              </div>
              <h2 className="text-3xl font-black tracking-tight">{benefit.title}</h2>
            </div>
            <p className="text-lg text-white/85 leading-relaxed">{benefit.description}</p>
          </div>

          <div className="flex gap-2">
            {benefits.map((b, index) => (
              <button
                key={b.title}
                onClick={() => setCurrentBenefit(index)}
                className={cn(
                  "h-1.5 rounded-full transition-all duration-300",
                  currentBenefit === index ? "bg-white w-8" : "bg-white/30 hover:bg-white/50 w-4"
                )}
                aria-label={`View benefit ${index + 1}`}
              />
            ))}
          </div>

          <div className="relative rounded-2xl overflow-hidden border border-white/20 shadow-2xl bg-white/5 backdrop-blur animate-scale-in">
            <img
              src={dashboardPreview}
              alt="Dashboard preview showing anonymous employee feedback analytics"
              className="w-full h-auto"
              loading="lazy"
            />
          </div>
        </div>
      </div>
    </div>
  );
};
